(function(window, $, undefined){

    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Controls = window.JVZoo.Controls || {};

    var editableItemListTagType = 'jvz-editable-list-ctl';
    var editableItemListTemplateTagType = 'jvz-editable-list-template';
    var addBtnTagType = 'jvz-editable-list-add-btn';
    var editableListItemCount = 0;
    var allEditableItemListControls = {};
    var removeButtonTagType = 'jvz-remove-btn';

    function RemoveButton(element) {
        var _this = this;
        //if we weren't passed a jQuery object, convert it to one now
        _this.$sourceElement = window.JVZoo.Common.AsjQueryObject(element);

        _this.$renderedElement = $('<div class="jvz-remove-btn" data-jvz-remove-btn>')
            .append($('<i class="fa fa-remove icon">'))
            .append(
                $("<input type='hidden' name='removed' data-is-removed='false'>")
                    .val('false')
            );
    }

    RemoveButton.prototype.render = function() {
        var _this = this;
        _this.$sourceElement.replaceWith(
            _this.$renderedElement
        );

        window.JVZoo.Controls.SetFullyQualifiedFieldNames(_this.$renderedElement);

        if (_this.$sourceElement.attr('data-is-removed') === 'true') {
            OnItemRemoved(_this.$renderedElement)
        }
    };

    var OnItemRemoved = function(target) {
        var $elementToRemove = window.JVZoo.Common.AsjQueryObject(target).closest('[data-form-field-index]');
        var $isRemovedInput = $elementToRemove.find('input[type=hidden][data-is-removed]');
        if (!$isRemovedInput || $isRemovedInput.length < 1) {
            console.error("Failed to find hidden input for [data-is-removed]")
        }
        $isRemovedInput.first().attr('data-is-removed', 'true').val('true');
        $elementToRemove.toggleClass('jvz-editable-list-item-removed');
    };

    window.JVZoo.Controls.RemoveButton = RemoveButton;

    var defaultItemGenerator = function() {
        return $('<div>').text(editableItemListTemplateTagType+" requires a function to generate new items.");
    };

    function EditableItemListControl(element) {
        var _this = this;

        _this.editableListItemCount = 0;
        _this.rendered = false;
        //if we weren't passed a jQuery object, convert it to one now
        _this.$editableListSourceElement = window.JVZoo.Common.AsjQueryObject(element);

        _this.errors = [];
        var errorPrefix = "Failed to create EditableItemListControl: ";
        var error = undefined;

        _this.name = _this.$editableListSourceElement.attr('name');
        if (!window.JVZoo.Common.IsString(_this.name, {minLength:1})) {
            error = "'name' attribute is required and cannot be empty.";
            console.error(error+" Error for element: ", window.JVZoo.Common.outerHtml(_this.$editableListSourceElement));
            _this.errors.push(error);
        }

        //verify a field prefix was set
        if (allEditableItemListControls.hasOwnProperty(_this.name)) {
            error = "'name' attribute must be unique required and cannot be empty.";
            console.error(error+" Error for element: ", window.JVZoo.Common.outerHtml(_this.$editableListSourceElement));
            _this.errors.push(error);
        }
        var sourceElementClasses = _this.$editableListSourceElement.attr('class') || '';
        /*
         * 2018-03-21 Adam Lenda
         * Currently Web Components is not universally supported. Google's polymer will get you close with polyfills,
         * but there is lots of caveats to that as well. Therefore, we use the following script to replace our
         * custom element tag with standard dom elements. Once Web Components is finally adopted by
         * all browsers we should switch to that.
         */
        _this.$editableListElement =
            $(
                //ensure we preserve any attributes that were supplied to the jvz-image-upload-ctl tag
                _this.$editableListSourceElement.clone(false)[0].outerHTML
                    .replace(window.JVZoo.Controls.FirstTagRegEx(editableItemListTagType), '$1div$2')
                    .replace(window.JVZoo.Controls.LastTagRegEx(editableItemListTagType), '$1div$2')
            )
                .attr('class', editableItemListTagType+' '+sourceElementClasses)
                .attr('data-'+editableItemListTagType, '');

        //check for an add button
        _this.$addButtonSourceElement = $(addBtnTagType+'[data-editable-list-add-btn="'+_this.name +'"]');
        if (_this.$addButtonSourceElement.length === 1) {
            var btnElementClasses = _this.$addButtonSourceElement.attr('class') || '';

            _this.$addButtonElement =
                $(
                    _this.$addButtonSourceElement.clone(false)[0].outerHTML
                        .replace(window.JVZoo.Controls.FirstTagRegEx(addBtnTagType), '$1a$2')
                        .replace(window.JVZoo.Controls.LastTagRegEx(addBtnTagType), '$1a$2')
                )
                .attr('href', "javascript:void(0);")
                .attr('class', ' '+addBtnTagType+' '+btnElementClasses);

            _this.$addButtonElement.on('click', function(event) {_this.addItem({});})
        }

        if (_this.errors.length > 0) {
            window.JVZoo.Controls.ShowErrorsForTag(_this.$editableListSourceElement, _this.errors);
            return;
        }

        _this.newItemGenerator = defaultItemGenerator;

        allEditableItemListControls[_this.name] = _this;
        return _this;
    }

    //static method to get editableItemListControl
    EditableItemListControl.getByFormFieldPrefix = function(name) {
        if (!window.JVZoo.Common.IsString(name, 1)) {
            console.error("EditableItemListControl.getByFormFieldPrefix does not accept an empty name parameter.");
            return undefined;
        }

        if (!allEditableItemListControls.hasOwnProperty(name)) {
            //try to find it...
            var $element = $(editableItemListTagType+'[name="'+name+'"]');
            if ($element.length > 0) {
                var editableItemListControl = new window.JVZoo.Controls.EditableItemListControl($element);
                editableItemListControl.render();
            }

            //still don't have it...
            if (!allEditableItemListControls.hasOwnProperty(name)) {
                console.error("Failed to find EditableItemListControl for name: '" + name + "'");
                return undefined;
            }
        }

        return allEditableItemListControls[name];
    };

    EditableItemListControl.prototype.setNewItemGenerator = function(newItemGenerator) {
        this.newItemGenerator = newItemGenerator;
    };

    //member function to add an item
    EditableItemListControl.prototype.addItem = function(data) {
        var _this = this;
        var $element = window.JVZoo.Common.AsjQueryObject(
            _this.newItemGenerator(data)
        );

        _this.$editableListElement.append($element);

        var editableListItemIndex = _this.editableListItemCount;
        _this.editableListItemCount += 1;

        $element.attr('data-form-field-index', editableListItemIndex);

        window.JVZoo.Controls.SetFullyQualifiedFieldNames($element);

        window.JVZoo.Controls.NewControlEvent.raise(_this, $element)
    };

    EditableItemListControl.prototype.render = function() {
        var _this = this;
        if(_this.rendered) {
            //already rendered
            return;
        }

        _this.$editableListSourceElement.replaceWith(_this.$editableListElement);
        window.JVZoo.Controls.SetFullyQualifiedFieldNames(_this.$editableListElement);

        _this.$addButtonSourceElement.replaceWith(_this.$addButtonElement);
        window.JVZoo.Controls.SetFullyQualifiedFieldNames(_this.$addButtonElement);
        _this.rendered = true;
        return _this;
    };

    window.JVZoo.Controls.EditableItemListControl = EditableItemListControl;

    var applyBindings = function($root) {
        $root.find(editableItemListTagType).each(function (index, value) {
            var $value = $(value);
            var editableItemListControl = window.JVZoo.Controls.EditableItemListControl.getByFormFieldPrefix($value.attr('name'));
            if (editableItemListControl) {
                editableItemListControl.render();
            }
        });

        $root.find(removeButtonTagType).each(function (index, value) {
                var removeButtonControl = new window.JVZoo.Controls.RemoveButton(value);
                removeButtonControl.render();
            }
        );

        $root.on("click", "[data-form-field-index] [data-jvz-remove-btn]", 'click', function (event) {
            OnItemRemoved(event.target);
        });
    };

    $(document).ready(function() {
        applyBindings($(document));
        window.JVZoo.Controls.NewControlEvent.subscribe(
            this,
            function(args) {
                applyBindings(window.JVZoo.Common.AsjQueryObject(args.targetElement));
            },
            {}
        )
    });
})(window, jQuery);